"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getSuggestedLocations = void 0;

var _api = _interopRequireDefault(require("../../http/api"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var getSuggestedLocations = function getSuggestedLocations(value) {
  return _api.default.get("/web-marketplace-api/v1/universal-search/cities-states?limit=30&q=".concat(encodeURIComponent(value)));
};

exports.getSuggestedLocations = getSuggestedLocations;